import {
  Heart,
  Briefcase,
  Megaphone,
  Store,
  Music,
  Users,
  PartyPopper,
  Lock,
  CalendarDays,
  Wine,
  Building2,
  Cake,
  Palette,
  Sparkles,
  GraduationCap,
  Trophy,
  Mic,
  CalendarCheck
} from "lucide-react";

const ICON_MAP = {
  // --- Categories ---
  "Wedding": Heart,
  "Corporate Event": Briefcase,
  "Brand Activation": Megaphone,
  "Exhibitions & Trade Shows": Store,
  "Concerts & Live Entertainment": Music,
  "Conference & Conventions": Users,
  "Social Celebrations": PartyPopper,
  "Private Event": Lock,
  "Holidays": CalendarDays,
  "Theme Party": Wine,
  "Government & Public Events": Building2,
  "Birthday & Anniversary": Cake,
  "Cultural Event": Palette,
  "Religious & Community Event": Sparkles,
  "College & Educational Events": GraduationCap,
  "Sports Event": Trophy,

  // --- Wedding Subcategories ---
  "Destination Wedding": Heart,
  "Luxury Wedding": Heart,
  "Traditional Wedding": Heart,
  "Wedding Anniversary": Heart,

  // --- Corporate Event Subcategories ---
  "Conferences": Users,
  "Seminars": Users,
  "Product Launches": Megaphone,
  "Annual Meets": Briefcase,
  "Award Ceremonies": Trophy,
  "Team Building Events": Users,
  "Offsites & Retreats": Briefcase,
  "Training Programs": GraduationCap,
  "Press Conferences": Megaphone,
  "Corporate Celebrations": PartyPopper,

  // --- Brand Activation Subcategories ---
  "Product Sampling": Megaphone,
  "In-Store Promotions": Store,
  "Mall Activations": Store,
  "Roadshows": Megaphone,
  "Society Activations": Users,
  "Campus Activations": GraduationCap,
  "Corporate Park Activations": Briefcase,
  "Retail Promotions": Store,
  "Experiential Marketing": Sparkles,
  "Promotional Campaigns": Megaphone,

  // --- Exhibitions & Trade Shows Subcategories ---
  "Trade Shows": Store,
  "Business Exhibitions": Store,
  "Consumer Exhibitions": Store,
  "Expos": Store,
  "Industry Fairs": Store,
  "B2B Exhibitions": Store,
  "B2C Exhibitions": Store,
  "Dealer Meets & Expos": Store,

  // --- Concerts & Live Entertainment Subcategories ---
  "Music Concerts": Music,
  "Live Shows": Music,
  "DJ Nights": Music,
  "Cultural Performances": Palette,
  "Stand-up Comedy Shows": Mic,
  "Theatre & Drama": Palette,
  "Celebrity Appearances": Sparkles,
  "Festivals": Music,

  // --- Social Celebrations Subcategories ---
  "Birthday Parties": Cake,
  "Anniversary Celebrations": Cake,
  "Baby Showers": Cake,
  "Housewarming Ceremonies": Sparkles,
  "Engagement Ceremonies": Heart,
  "Retirement Parties": PartyPopper,
  "Family Gatherings": Users,
  "Private Parties": Lock,

  // --- College & Educational Events Subcategories ---
  "College Festivals": PartyPopper,
  "School Events": GraduationCap,
  "Convocations": GraduationCap,
  "Freshers' Parties": PartyPopper,
  "Farewell Events": PartyPopper,
  "Cultural Festivals": Palette,
  "Technical Festivals": GraduationCap,
  "Alumni Meets": Users,
  "Educational Conferences": Users,

  // --- Sports Event Subcategories ---
  "Marathons & Runs": Trophy,
  "Cricket Tournaments": Trophy,
  "Football Tournaments": Trophy,
  "Badminton Tournaments": Trophy,
  "Tennis Tournaments": Trophy,
  "Indoor Sports Events": Trophy,
  "Outdoor Sports Events": Trophy,
  "Fitness Events": Trophy,
  "Cycling Events": Trophy,
  "Esports Tournaments": Trophy,

  // --- Religious & Community Event Subcategories ---
  "Religious Festivals": Sparkles,
  "Spiritual Gatherings": Sparkles,
  "Processions": Sparkles,
  "Cultural Celebrations": Palette,
  "Community Festivals": Sparkles,
  "Community Gatherings": Users,
  "Charity & NGO Events": Heart,
  "Public Celebrations": Users,
  "RWA & Society Events": Users,
  "Social Awareness Events": Megaphone,

  // --- Government & Public Events Subcategories ---
  "Government Ceremonies": Building2,
  "Public Awareness Campaigns": Megaphone,
  "Government Conferences": Building2,
  "Government Summits & Forums": Building2,
  "Official Inaugurations": Building2,
  "Civic Events": Building2,
  "State Functions": Building2,
  "Public Outreach Programs": Megaphone,
  "National Day Celebrations": CalendarDays,
  "Public Welfare Events": Sparkles,
};

export const getEventIcon = (eventTypeName) => {
  if (!eventTypeName) return CalendarCheck;
  
  const normalized = eventTypeName.trim();
  
  // Try exact match first
  if (ICON_MAP[normalized]) {
    return ICON_MAP[normalized];
  }
  
  // Try case-insensitive match
  const lowerName = normalized.toLowerCase();
  const foundKey = Object.keys(ICON_MAP).find(
    (key) => key.toLowerCase() === lowerName
  );
  
  if (foundKey) {
    return ICON_MAP[foundKey];
  }
  
  // Fallbacks based on common substrings
  if (lowerName.includes("wedding") || lowerName.includes("marriage")) return Heart;
  if (lowerName.includes("corporate") || lowerName.includes("business") || lowerName.includes("office")) return Briefcase;
  if (lowerName.includes("birthday") || lowerName.includes("anniversary")) return Cake;
  if (lowerName.includes("party") || lowerName.includes("celebration")) return PartyPopper;
  if (lowerName.includes("sports") || lowerName.includes("tournament") || lowerName.includes("match") || lowerName.includes("run") || lowerName.includes("race")) return Trophy;
  if (lowerName.includes("concert") || lowerName.includes("music") || lowerName.includes("show") || lowerName.includes("dj")) return Music;
  if (lowerName.includes("school") || lowerName.includes("college") || lowerName.includes("education") || lowerName.includes("university")) return GraduationCap;
  if (lowerName.includes("government") || lowerName.includes("civic") || lowerName.includes("official") || lowerName.includes("public")) return Building2;
  if (lowerName.includes("religious") || lowerName.includes("spiritual") || lowerName.includes("temple") || lowerName.includes("church") || lowerName.includes("community")) return Sparkles;
  
  return CalendarCheck; // Default fallback icon
};
